namespace $.$$ {
	
	$mol_style_define( $giper_baza_app_stat_list, {
		
		Menu: {
			flex: {
				basis: '30rem',
			},
		},
		
		Menu_link: {
			justify: {
				content: 'space-between',
			},
		},
		
		Menu_link_title: {
			flex: {
				grow: 1,
			},
		},
		
	} )
	
}
